import { render, staticRenderFns } from "./CommentFormModal.vue?vue&type=template&id=0699d85f&"
import script from "./CommentFormModal.vue?vue&type=script&lang=js&"
export * from "./CommentFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports